import '.dq{line-height:1.75rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ReactNode } from 'react'

export const ParagraphedText = ({
  children,
}: {
  children?: string
}): ReactNode | null => {
  if (!children) {
    return <br key={0} />
  }

  return children.split('\n').map((p, index) =>
    p.trim() !== '' ? (
      <p className="dq" key={index}>
        {p}
      </p>
    ) : (
      <br key={index} />
    ),
  )
}
